import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import ContactMailRoundedIcon from '@mui/icons-material/ContactMailRounded';
import PersonSearchRoundedIcon from '@mui/icons-material/PersonSearchRounded';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';
import {
  Accordion,
  AccordionDetails,
  Box,
  Button,
  ButtonGroup,
  Grid,
  IconButton,
  List,
  ListItem,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { companyTypes, ticketType } from 'data/enum';
import GetPriorityColor from 'functions/GetPriorityColor';
import useWindowsDimension from 'functions/useWindowsDimension';
import { rq, rqPost } from 'http/apiRoutes';
import { useGet, usePost } from 'http/useApi';
import { useEffect, useReducer, useState } from 'react';

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { ICompanyProductViewModel } from 'Interfaces/ICompanyProductConfig';
import {
  EnumObjectType,
  EnumPriority,
  EnumSupportBilling,
  IAddressViewModel,
  objectArray,
} from 'Interfaces/IGlobalTypeConfig';
import { ScheduleView } from 'components/ui/ScheduleView';
import { useAtom } from 'jotai';
import { ObjectDrawer } from 'pages/Companies/ObjectDrawer';
import {
  IEmployeeWithCompanyViewModel,
  INewTicketAddWithProductInitialState,
  ITicketAddWithProductViewModel,
  ITicketCompanyViewModel,
  ITicketPostAddViewModel,
} from '../../Interfaces/ITicketConfig';

import DevicesOtherRoundedIcon from '@mui/icons-material/DevicesOtherRounded';
import { FormAccordionSummary, FormBox } from 'components/form';
import { SingleAutoAnswerView } from 'components/ui/SingleAutoAnswerView';
import { SingleTicketContactProduct } from 'components/ui/SingleTicketContactProduct';
import { IAutoAnswersViewModel } from 'pages/AutoAnswersConfig';

import AttachFileIcon from '@mui/icons-material/AttachFile';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import TextsmsRoundedIcon from '@mui/icons-material/TextsmsRounded';
import {
  DesktopDateTimePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { SearchFilter } from 'components/ui/SearchFilter';
import { SingleTicketEmployeeView } from 'components/ui/SingleTicketEmployeeView';
import { SwitchType } from 'components/ui/SwitchType';
import {
  boxStyle,
  gridStyle,
  ProductFormStyle,
  TextStyle,
} from 'data/FontStyle';
import userAtom from 'data/atoms/userAtom';
import { ticketCommunicationStatus } from 'data/enum';
import dayjs from 'dayjs';
import { EconomyView } from 'functions/EconomySimpleView';
import { isGuidEmpty, isValidGuid } from 'functions/GuidChecks';
import { useGetObjectList } from 'functions/useGetObjectList';
import { useTranslation } from 'react-i18next';
//@ts-ignore
import DocumentUploader from '../../components/ui/DocumentUploader';

//@ts-ignore
import { SupportAgent } from '@mui/icons-material';
import { ICompanyViewModel } from 'Interfaces/ICompaniesConfig';
import { IEmployeeViewModel } from 'Interfaces/IEmployeeConfig';
import { SingleTicketCompanyView } from 'components/ui/SingleTicketCompanyView';
import ratesAtom from 'data/atoms/ratesAtom';
import CalculateTotalTime from 'functions/CalculateTotalTime';
import { ConvertToAddTicketPost } from 'functions/ConvertToAddTicketPost';
import { ConvertToAttachment } from 'functions/ConvertToAttachment';
import { checkForOvertime } from 'functions/checkForOvertime';
import { isEmptyObject } from 'functions/isEmpotyObject';
import { CompaniesDrawer } from 'components/ui/Drawers/CompaniesDrawer';
import { CompanyProductDrawer } from 'components/ui/Drawers/CompanyProductDrawer';
import { EmployeeDrawer } from 'components/ui/Drawers/EmployeeDrawer';
import { useNavigate } from 'react-router';
import { initialRootState, RootReducer } from './Components/RotTicketReducer';
import { ConvertStateToTicketUpdateWithProductViewModel } from './TicketDetails';
import { GetWorkRole } from 'functions/GetWorkRole';
let _ = require('lodash');

function sleep(ms: any) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const ConvertStateToTicketAddWithProductViewModel = (
  state: INewTicketAddWithProductInitialState,
  user: any
) => {
  let deliveryAddressPostalCode = state.deliveryAddress?.postalCode
    ? state.deliveryAddress.postalCode.toString()
    : '';

  let obj: ITicketAddWithProductViewModel = {
    ccEmailList: state.ccEmailList,
    toEmailList: state.toEmailList,
    board: state.board,
    priority: state.priority,
    status: state.status,
    ticketNo: state.ticketNo,
    deliveryDate: state.scheduleTime.deliveryDate,
    scheduled: state.scheduleTime.startDate,
    ETCHours: state.scheduleTime.estimatedTime.hours,
    ETCMinutes: state.scheduleTime.estimatedTime.minutes,
    jobType: state.jobType,
    supportTypeId: state.supportType.id,
    errorDescriptionId: state.errorDescription.id,
    companyId: state.companyId,
    contactId: state.contactId,
    creatorId: user.id,
    responsibleId: state.responsibleId || null,

    shippingCost: state.shippingCost,

    deliveryStreet: state.deliveryAddress?.street ?? '',
    deliveryPostalCode: deliveryAddressPostalCode,
    deliveryArea: state.deliveryAddress.area || '',
    deliveryCity: state.deliveryAddress.city || '',
    deliveryCountry: state.deliveryAddress.country || '',
    deliveryPostbox: state.deliveryAddress.postBox || '',

    attention: state.deliveryAddress.attention || '',
    comment: state.comment,
    fixedHourlyRate: 0,
    fixedTime: 0,
    fixedPrice: 0,
    maxTime: 0,
    maxPrice: 0,

    productBilling: state.productBilling,
    billing: state.billing,
    title: state.title,
    companyProductId: state.companyProduct.id,

    companyProducts: state.companyProducts,
    productCatalog: state.productCatalog,
    storageProducts: state.storageProducts,
    unassignedCompanyProducts: state.unassignedCompanyProducts,
    techniciansId: state.techniciansId,
    supportBilling: EnumSupportBilling.BillOnCompletion,
  };

  return obj;
};

export interface ticketAndPostState {
  ticket: ITicketAddWithProductViewModel;
  ticketPost: ITicketPostAddViewModel;
}
export const ticketAndPost: ticketAndPostState = {
  ticket: {} as ITicketAddWithProductViewModel,
  ticketPost: {} as ITicketPostAddViewModel,
};

export const ToAddTicket = (ticket: ITicketAddWithProductViewModel) => {
  let obj: ITicketAddWithProductViewModel = {
    ccEmailList: ticket.ccEmailList,
    toEmailList: ticket.toEmailList,
    board: ticket.board,
    priority: ticket.priority,
    status: ticket.status,
    ticketNo: ticket.ticketNo,
    deliveryDate: ticket.deliveryDate,
    scheduled: ticket.scheduled,
    ETCHours: ticket.ETCHours,
    ETCMinutes: ticket.ETCMinutes,
    jobType: ticket.jobType,
    supportTypeId: ticket.supportTypeId,
    errorDescriptionId: ticket.errorDescriptionId,
    companyId: ticket.companyId,
    contactId: ticket.contactId,
    creatorId: ticket.creatorId,
    responsibleId: ticket.responsibleId || null,
    shippingCost: ticket.shippingCost,
    deliveryStreet: ticket.deliveryStreet,
    deliveryPostalCode: ticket.deliveryPostalCode,
    deliveryArea: ticket.deliveryArea,
    deliveryCity: ticket.deliveryCity,
    deliveryCountry: ticket.deliveryCountry,
    deliveryPostbox: ticket.deliveryPostbox,
    attention: ticket.attention,
    comment: ticket.comment,
    fixedHourlyRate: ticket.fixedHourlyRate,
    fixedTime: ticket.fixedTime,
    fixedPrice: ticket.fixedPrice,
    maxTime: ticket.maxTime,
    maxPrice: ticket.maxPrice,
    productBilling: ticket.productBilling,
    billing: ticket.billing,
    title: ticket.title,
    companyProductId: ticket.companyProductId,
    companyProducts: ticket.companyProducts,
    productCatalog: ticket.productCatalog,
    storageProducts: ticket.storageProducts,
    unassignedCompanyProducts: ticket.unassignedCompanyProducts,
    techniciansId: ticket.techniciansId,
    supportBilling: ticket.supportBilling,
  };

  return obj;
};

export const NewTicket = () => {
  /* INITIALIZE */
  // let navigate = useNavigate();
  const { t } = useTranslation();
  const { height } = useWindowsDimension();
  const [user] = useAtom(userAtom);
  const [rates] = useAtom(ratesAtom);
  let navigate = useNavigate();

  //const [state, dispatch] = useReducer(reducer, initialState);
  const [state, dispatch] = useReducer(RootReducer, initialRootState);

  const [selectedDocuments, setSelectedDocuments] = useState<any>([]);

  // states
  const [options, setOptions] = useState<any>([]);
  const loading = options.length === 0;
  const hasNonInternalMessages = state.ticketPost.ticketPosts.some(
    (post) => post.internal === false
  );
  // api
  const [isObjectList, setIsObjectList] = useState<boolean>(true);
  let companyId = 'new';
  let employeeId = 'new';
  let departmentId = 'new';
  let resourceId = 'new';
  let objectDrawerList: objectArray[] = useGetObjectList(
    companyId ?? 'new',
    employeeId ?? 'new',
    departmentId ?? 'new',
    resourceId ?? 'new',
    isObjectList
  );
  useEffect(() => {
    // setResource(objectDrawerList[Number(EnumObjectType.Resource)].objectList);
    console.log('ghg objectDrawerList', objectDrawerList);
    setIsObjectList(false);
  }, [objectDrawerList]);

  const { data: mobileAutoAnswersData } = useGet(
    rq.mobileAutoAnswers('BBB00BBB-6C0C-4C0C-8C0C-BBB001BBB001', true),
  );

  let isEnabled =
    state.company?.id !== 'new' && state.employee.employee?.id !== 'new'
      ? true
      : false;
  console.log(
    'ghg isEnabled',
    isEnabled,
    state.company?.id,
    state.employee.employee?.id
  );

  isEnabled = state.company.id !== 'new' ? true : false;
  //const { data: employeeData } = useGet(rq.allEmployees(isEnabled), isEnabled);

  const postTicketAndPost = usePost(rqPost.ticketAndPost(isEnabled),);
  useEffect(() => {
    if (rates) {
      dispatch({
        type: 'SET_RATES',
        payload: rates,
      });
    }
  }, [rates]);
  /* FUNCTIONS */
  const isEditDisabled = () => {
    let isDisabled: boolean = false;
    console.log('isEditDisabled', state.employee?.employee?.id);
    if (state.employee?.employee?.id === 'new') {
      isDisabled = true;
    }
    if (state.ticket.title.length <= 0) {
      isDisabled = true;
    }
    if (
      state.ticketPost.ticketPost.message.length <= 0 &&
      state.ticketPost.ticketPost.status !== 15
    ) {
      isDisabled = true;
    }
    return isDisabled;
  };
  const autoAnswerIsObject = (object: any) => {
    return typeof object === 'object';
  };
  // HANDLES
  const handleChangeWorkRole = (
    event: any,
    selectedObject: any,
    objectType: EnumObjectType
  ) => {
    switch (objectType) {
      case EnumObjectType.WorkRole:
        console.log('handleChangeWorkRole', selectedObject, objectType);
        //dispatch({ type: 'SET_WORK_ROLE', payload: selectedObject });

        let workRole = GetWorkRole(
          selectedObject,
          user.workRole,
          state.ticketPost.ticketPost.workRole
        );
        if (workRole) {
          dispatch({
            type: 'SET_WORK_ROLE',
            payload: workRole,
          });
        }

        break;
    }
  };
  const handleChangeCompanyProductWidthError = (
    event: any,
    companyProduct: ICompanyProductViewModel
  ) => {
    dispatch({ type: 'SET_COMPANY_PRODUCT', payload: companyProduct });
  };
  const handlePriorityChange = (e: any, priority: EnumPriority) => {
    e.preventDefault();
    dispatch({ type: 'SET_PRIORITY', payload: priority });
  };
  const handleChangeEmployee = (
    e: React.MouseEvent<HTMLElement>,
    employee: IEmployeeViewModel
  ) => {
    e.preventDefault();

    // setter ny contact
    dispatch({
      type: 'SET_CONTACT',
      payload: employee,
    });
    dispatch({
      type: 'SET_EMPLOYEE',
      payload: employee,
    });

    //setter ny contact i ticketpost
    dispatch({
      type: 'SET_TICKET_POST_RECEIVER',
      payload: employee,
    });

    dispatch({
      type: 'SET_IS_DIRTY',
      payload: true,
    });

    setIsObjectList(false);
  };
  const handleChangeCompany = (
    e: React.MouseEvent<HTMLElement>,
    company: ICompanyViewModel
  ) => {
    e.preventDefault();
    setIsObjectList(true);
    console.log('handleChangeCompany', company);
    let employee: IEmployeeWithCompanyViewModel = {
      id: 'new',
      name: '',
      department: '',
      phone: '',
      email: '',
      budget: 0,
      title: '',
      url: '',
      workRole: null,
      company: {} as ITicketCompanyViewModel,
      departmentAddress: {} as IAddressViewModel,
      companyAddress: company.mainAddress,
      homeOffice: company?.contact?.address || undefined || null,
    };

    // check if company.contact exist if so convert it to employee
    if (company.contact) {
      employee.id = company.contact?.id ?? 'new';
      employee.name = company.contact.name;
      employee.departmentAddress = company.mainAddress;
      employee.phone = company.contact.phone;
      employee.email = company.contact.email;
      employee.budget = company.contact.budget;
      employee.title = company.contact.title;
      employee.url = company.contact.url;
      employee.workRole = company.contact.workRole;
      employee.company = company;
      employee.departmentAddress = company.mainAddress;
      employee.companyAddress = company.mainAddress;
      employee.homeOffice = company.mainAddress;
    }
    // sett selected company
    dispatch({
      type: 'SET_TICKET_COMPANY',
      payload: company,
    });
    dispatch({
      type: 'SET_COMPANY',
      payload: company,
    });
    // sett tom employee
    dispatch({
      type: 'SET_CONTACT',
      payload: employee,
    });
    dispatch({
      type: 'SET_EMPLOYEE',
      payload: employee,
    });
    dispatch({
      type: 'SET_TICKET_POST_RECEIVER',
      payload: employee,
    });
    // sett ticketpoast toemail
    dispatch({
      type: 'SET_TICKET_POST_TO_EMAIL',
      payload: employee.email,
    });
    //sett ticket ccemail
    dispatch({
      type: 'SET_CC_EMAIL',
      payload: employee.email,
    });

    let workRole = GetWorkRole(
      company?.workRole ?? null,
      user.workRole,
      state.ticketPost.ticketPost.workRole
    );
    // console.log('GetWorkRole w', workRole);
    if (workRole) {
      dispatch({
        type: 'SET_WORK_ROLE',
        payload: workRole,
      });
    }
    dispatch({
      type: 'SET_IS_DIRTY',
      payload: true,
    });
  };
  const handleChangeAutoAnswer = (
    event: any,
    autoAnswer: IAutoAnswersViewModel
  ) => {
    console.log('handleChangeAutoAnswer', autoAnswer);
    // console.log('handleChangeAutoAnswer', autoAnswer);
    dispatch({
      type: 'SET_AUTO_ANSWER',
      payload: autoAnswer,
    });
  };
  const handleChangeSchedule = (changeType: string, e: any) => {
    let scheduleTime = { ...state.ticket.scheduleTime };
    switch (changeType.toUpperCase()) {
      case 'HOURS':
        scheduleTime.estimatedTime.hours = e;
        break;
      case 'MINUTES':
        scheduleTime.estimatedTime.minutes = e;
        break;
    }
    dispatch({
      type: 'SET_SCHEDULE_TIME',
      payload: scheduleTime,
    });
  };
  const handleChangeTitle = (e: any) => {
    dispatch({ type: 'EDIT_TITLE', payload: e.target.value });
    dispatch({ type: 'SET_DIRTY', payload: true });
  };
  const handleChangeResponsable = (e: any, employee: IEmployeeViewModel) => {
    e.preventDefault();

    /* let ticketResponsible = {
      ticketId: state.ticketPost.ticket.id,
      responsibleId: employee.id,
    };
    //putTicketResponsible.mutate(ticketResponsible);
    let ticket = _.cloneDeep(state.ticketPost.ticket);
    ticket.responsible = employee; */
    console.log('yyy handleChangeResponsable', employee);
    dispatch({
      type: 'SET_TICKET_POST_RESPONSIBLE',
      payload: employee,
    });
    dispatch({
      type: 'SET_RESPONSIBLE',
      payload: employee,
    });
  };
  const handleAssigneMe = () => {
    console.log('handleAssigneMe', user);

    dispatch({
      type: 'SET_RESPONSIBLE',
      payload: user,
    });
    //putTicketResponsible.mutate(ticketResponsible);
    let ticket = _.cloneDeep(state.ticketPost.ticket);
    ticket.responsible = user;
    /*  dispatch({
        type: 'SET_TICKET',
        payload: ticket,
      }); */
  };
  const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    event.target.select();
  };
  const handleSetTime = (e: any, interval: number) => {
    e.preventDefault();
    dispatch({
      type: 'SET_END_DATE',
      payload: dayjs(state.ticketPost.ticketPost.endTime).add(
        interval,
        'minute'
      ),
    });
  };
  const handleChangeCC = (e: any) => {
    dispatch({ type: 'EDIT_CC', payload: e.target.value });
  };
  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(3e3); // For demo purposes.

      if (active) {
        setOptions([...ticketType]);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);
  useEffect(() => {
    if (mobileAutoAnswersData) {
      // console.log('mobileAutoAnswersData', mobileAutoAnswersData);
      let autoAnswers = mobileAutoAnswersData.mobileAutoAnswers;
      dispatch({ type: 'SET_AUTO_ANSWERS', payload: autoAnswers });
      dispatch({ type: 'SET_AUTO_ANSWER', payload: autoAnswers[5] });
    }
  }, [mobileAutoAnswersData]);
  const onSubmit = async () => {
    let _state = _.cloneDeep(state.ticketPost);
    let newTicket = ConvertStateToTicketUpdateWithProductViewModel(
      state.ticket,
      user
    );
    let ticketPost = ConvertToAddTicketPost(_state, newTicket, user);
    /*     console.log('papa NEW TICKET to post', newTicket);
    ticketPost.receiverId = newTicket.contactId || 'new';
 */ if (selectedDocuments.length > 0) {
      ticketPost.attachments = ConvertToAttachment(selectedDocuments) ?? [];
    } else {
      ticketPost.attachments = [];
    }

    let ticketAndPost = {
      ticket: newTicket,
      ticketPost: ticketPost,
    };

    console.log('papa TICKETPOST POST', ticketAndPost);

    postTicketAndPost.mutate(ticketAndPost, {
      onSuccess: (res: any) => {
        console.log('papa postTicketPost', res);
        dispatch({
          type: 'RESET_TICKET_STATE',
        });
        dispatch({
          type: 'EDIT_COMMENT',
          payload: '',
        });
        navigate(`/tickets/${res.ticket.id}/communications`);
      },
    });
  };
  useEffect(() => {
    // console.log('...selected documents', selectedDocuments);
    if (selectedDocuments.length > 0) {
      dispatch({
        type: 'CHANGE_ATTACHMENTS',
        payload: selectedDocuments,
      });
    }
  }, [selectedDocuments]);
  useEffect(() => {
    if (state.ticketPost.rates && state.ticketPost.rates.length > 0) {
      console.log('XXX TICKETPOST : useeffact', state.ticketPost);
      if (
        state.ticketPost.ticket.fixedHourlyRate === undefined ||
        state.ticketPost.ticket.fixedHourlyRate === null
      ) {
        state.ticketPost.ticket.fixedHourlyRate = -1;
      }

      //check if overtime
      if (state.ticketPost.rates) {
        let isShowOverTime = checkForOvertime(
          state.ticketPost.rates,
          state.ticketPost.ticketPost.endTime.hour(),
          state.ticketPost.ticketPost.endTime.minute()
        );
        dispatch({
          type: 'SET_SHOW_OVERTIME',
          payload: isShowOverTime,
        });
        // console.log('economy - ');
        dispatch({
          type: 'SET_TOTAL_TIME',
          payload: CalculateTotalTime(
            state.ticketPost.ticketPost.startTime,
            state.ticketPost.ticketPost.endTime,
            null,
            null
          ) as string,
        });
      }
      // update tickeptostbilling
      dispatch({
        type: 'UPDATE_TICKET_POST_BILLING',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    state.ticketPost.ticketPost.workRole,
    state.ticketPost.ticketPost.isBillable,
    state.ticketPost.ticketPost.isOvertime,
    state.ticketPost.ticketPost.isInHouse,
    state.ticketPost.rates,
    state.ticketPost.ticketPost.startTime,
    state.ticketPost.ticketPost.endTime,
    state.ticketPost.ticketPost,
  ]);
  // RENDER

  console.log(
    'isEmptyObject',
    isEmptyObject(state.ticket?.companyProductWithError)
  );

  return (
    <Grid container sx={{ m: 0, p: 0, display: 'flex', flexDirection: 'row' }}>
      <Grid
        item
        xs={12}
        sx={{
          mb: 1,
        }}
      >
        <Paper
          variant='elevation3'
          sx={{
            p: 2,
            borderRadius: 2,
            backgroundColor: 'primary.main',
          }}
        >
          {/* HEADER  */}
          <Grid container display={'flex'} direction='row' flexGrow={1}>
            <Grid item xs={4} display={'flex'} flexDirection={'row'}>
              <SupportAgent sx={{ fontSize: 32, m: 0 }} />
              <Typography
                sx={{
                  m: 0,
                  ml: 0.5,
                  pt: 1,
                  flexGrow: 1,
                  textTransform: 'uppercase',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  fontWeight: 'bold',
                  fontSize: 14,
                  letterSpacing: 2,
                }}
              >
                {t('Ticket.newTicket')}
              </Typography>
            </Grid>
            <Grid
              item
              xs={8}
              sx={{
                flexGrow: 1,
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Grid item xs={3} sx={{ pr: 2 }}>
                <Select
                  sx={{ width: '100%', p: 0, mt: -0.5 }}
                  labelId='Board'
                  id='Board'
                  variant='standard'
                  value={state.ticket.board}
                  label='Board'
                  onChange={(e) => {
                    dispatch({ type: 'SET_BOARD', payload: e.target.value });
                  }}
                >
                  <MenuItem value={0}>{t('Ticket.sale')}</MenuItem>
                  <MenuItem value={1}>{t('Ticket.support')}</MenuItem>
                  <MenuItem value={2}>{t('Ticket.project')}</MenuItem>
                </Select>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      {/* LEFT SIDE  */}
      <Grid
        item
        xs={5}
        sx={{
          m: 0,
          pr: 0.5,
        }}
      >
        <Paper
          variant='elevation3'
          sx={{
            height: Math.ceil(height - 102),
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'primary.main',
            p: 1,
          }}
        >
          <Grid
            container
            sx={{
              m: 0,
              p: 0,
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            {/* TICKET HEADER */}
            <Grid item xs={12} sx={{ p: 0, pr: 1, mb: 1 }}>
              <FormBox Icon={SupportAgent} title={t('Ticket.ticketTitle')} />
            </Grid>
            {/* TICKET TITLE */}
            <Grid
              item
              xs={12}
              sx={{ mb: 1 }}
              display={'flex'}
              flexDirection={'row'}
            >
              <TextField
                autoFocus
                id='name'
                label='Title'
                type='text'
                fullWidth
                variant='standard'
                value={state.ticket?.title || ''}
                onChange={(e) => handleChangeTitle(e)}
                onFocus={handleFocus}
                sx={{ mr: 2, backgroundColor: 'rgba(0,0,0,0.1)' }}
              />
            </Grid>
            {/* ASSIGN CUSTOMER EMPLOYEE HEADER */}
            <Grid item xs={12} sx={{ p: 0, mb: 1 }}>
              <FormBox
                Icon={PersonSearchRoundedIcon}
                title={t('Ticket.assignCompanyEmployee')}
              />
            </Grid>
            <Typography
              sx={{
                m: 0,
                pt: 1,
                flexGrow: 1,
                textTransform: 'uppercase',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontWeight: 'normal',
                fontSize: 12,
                letterSpacing: 2,
                width: '43%',
              }}
            >
              {t('Ticket.selectCompany')}
            </Typography>
            <Typography
              sx={{
                m: 0,
                pt: 1,
                flexGrow: 1,
                textTransform: 'uppercase',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontWeight: 'normal',
                fontSize: 12,
                letterSpacing: 2,
                width: '40%',
              }}
            >
              {t('Ticket.selectEmployee')}
            </Typography>
            {/* ASSIGN CUSTOMER EMPLOYEE */}
            <Grid item xs={6} sx={{ p: 0, mb: 2, position: 'relative' }}>
              {state.ticket.company.id !== undefined ? (
                <Stack direction='column'>
                  <SingleTicketCompanyView company={state.ticket.company} />
                  <Grid
                    item
                    sx={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      pointerEvents: hasNonInternalMessages ? 'none' : 'auto',
                      opacity: hasNonInternalMessages ? 0.5 : 1,
                    }}
                  >
                    <CompaniesDrawer
                      buttonContext={t('Ticket.TicketDetails.selectEmployee')}
                      buttonIcon={<ChangeCircleIcon sx={{ fontSize: 26 }} />}
                      handleChange={handleChangeCompany}
                    />
                  </Grid>
                </Stack>
              ) : (
                <Grid
                  item
                  sx={{
                    width: '100%',
                    height: '100%',
                  }}
                >
                  <CompaniesDrawer
                    buttonContext={t('Ticket.TicketDetails.selectCompany')}
                    buttonIcon={null}
                    handleChange={handleChangeCompany}
                  />
                </Grid>
              )}
            </Grid>
            <Grid item xs={6} sx={{ p: 0, mb: 2, position: 'relative' }}>
              {state.ticket.company.id !== undefined &&
              state?.ticket.contact?.id !== 'new' ? (
                <Stack direction='column'>
                  <SingleTicketEmployeeView
                    employee={state.ticket.contact}
                    priority={state.ticket.priority}
                  />
                  <Grid
                    item
                    sx={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                    }}
                  >
                    <EmployeeDrawer
                      buttonContext={t('Ticket.TicketDetails.selectEmployee')}
                      buttonIcon={<ChangeCircleIcon sx={{ fontSize: 26 }} />}
                      handleChange={handleChangeEmployee}
                      companyId={state.ticket.company?.id}
                    />
                  </Grid>
                </Stack>
              ) : (
                <Grid
                  item
                  sx={{
                    width: '100%',
                    height: '100%',
                  }}
                >
                  <EmployeeDrawer
                    buttonContext={t('Ticket.TicketDetails.selectEmployee')}
                    buttonIcon={null}
                    handleChange={handleChangeEmployee}
                    companyId={state.ticket.company?.id}
                  />
                </Grid>
              )}
            </Grid>

            {/* PRIORITY HEADER */}
            <Grid item xs={12} sx={{ p: 0, mb: 1, mt: 0 }}>
              <FormBox
                Icon={PriorityHighRoundedIcon}
                title={t('Priority.header')}
              />
            </Grid>
            {/* PRIORITY BUTTONS  */}
            <Grid
              item
              xs={12}
              sx={{
                p: 0,
                mb: 2,
                flexGrow: 1,
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <ButtonGroup
                variant='contained'
                aria-label='outlined primary button group'
                size='small'
                sx={{ width: '100%', backgroundColor: 'red' }}
              >
                <Button
                  key='NONE'
                  sx={{
                    width: '20%',
                    backgroundColor:
                      state.ticket.priority === EnumPriority.NONE
                        ? GetPriorityColor(state.ticket.priority)
                        : 'primary.back',
                    '&:hover': {
                      backgroundColor: GetPriorityColor(EnumPriority.NONE),
                    },
                  }}
                  onClick={(e) => {
                    handlePriorityChange(e, 0);
                  }}
                >
                  {t('Priority.none')}
                </Button>
                <Button
                  key='LOW'
                  sx={{
                    width: '20%',
                    backgroundColor:
                      state.ticket.priority === EnumPriority.LOW
                        ? GetPriorityColor(state.ticket.priority)
                        : 'primary.back',
                    '&:hover': {
                      backgroundColor: GetPriorityColor(EnumPriority.LOW),
                    },
                  }}
                  onClick={(e) => {
                    handlePriorityChange(e, 1);
                  }}
                >
                  {t('Priority.low')}
                </Button>
                <Button
                  key='NORMAL'
                  sx={{
                    width: '20%',
                    backgroundColor:
                      state.ticket.priority === EnumPriority.NORMAL
                        ? GetPriorityColor(state.ticket.priority)
                        : 'primary.back',
                    '&:hover': {
                      backgroundColor: GetPriorityColor(EnumPriority.NORMAL),
                    },
                  }}
                  onClick={(e) => {
                    handlePriorityChange(e, 2);
                  }}
                >
                  {t('Priority.normal')}
                </Button>
                <Button
                  key='HIGH'
                  sx={{
                    width: '20%',
                    backgroundColor:
                      state.ticket.priority === EnumPriority.HIGH
                        ? GetPriorityColor(state.ticket.priority)
                        : 'primary.back',
                    '&:hover': {
                      backgroundColor: GetPriorityColor(EnumPriority.HIGH),
                    },
                  }}
                  onClick={(e) => {
                    handlePriorityChange(e, 3);
                  }}
                >
                  {t('Priority.high')}
                </Button>

                <Button
                  key='CRITICAL'
                  sx={{
                    width: '20%',
                    backgroundColor:
                      state.ticket.priority === EnumPriority.CRITICAL
                        ? GetPriorityColor(state.ticket.priority)
                        : 'primary.back',
                    '&:hover': {
                      backgroundColor: GetPriorityColor(EnumPriority.CRITICAL),
                    },
                  }}
                  onClick={(e) => {
                    handlePriorityChange(e, 4);
                  }}
                >
                  {t('Priority.critical')}
                </Button>
              </ButtonGroup>
            </Grid>
            {/* ISSUE HEADER */}
            <Grid item xs={12} sx={{ p: 0, pr: 1, mb: 1 }}>
              <FormBox
                Icon={DevicesOtherRoundedIcon}
                title={t('Ticket.type')}
              />
            </Grid>
            {/* ISSUE TYPE */}
            <Grid item xs={5} sx={{ m: 0, pr: 1, mb: -1 }}>
              {!autoAnswerIsObject(state.ticket?.supportType) ? (
                <>
                  <ObjectDrawer
                    buttonContext={'Select Issue Type'}
                    buttonIcon={null}
                    objectList={!!objectDrawerList ? objectDrawerList : []}
                    objectType={[EnumObjectType.IssueType]}
                    handleChange={handleChangeAutoAnswer}
                    buttonHeight={80}
                    buttonWidth={'100%'}
                  />
                </>
              ) : (
                <>
                  <SingleAutoAnswerView
                    autoAnswer={state.ticket?.supportType}
                  />
                  <Grid
                    item
                    sx={{
                      position: 'relative',
                      bottom: 78,
                      right: 4,
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <ObjectDrawer
                      buttonContext={'Select Issue Type'}
                      buttonIcon={<ChangeCircleIcon sx={{ fontSize: 26 }} />}
                      objectList={!!objectDrawerList ? objectDrawerList : []}
                      objectType={[EnumObjectType.IssueType]}
                      handleChange={handleChangeAutoAnswer}
                      buttonHeight={30}
                      buttonWidth={30}
                    />
                  </Grid>
                </>
              )}
            </Grid>
            <Grid item xs={7} sx={{ m: 0, pr: 1 }}>
              <Typography
                sx={{
                  m: 0,
                  pl: 1,
                  mt: -1,
                  flexGrow: 1,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  fontWeight: 'normal',
                  fontSize: 12,
                  letterSpacing: 2,
                  width: '100%',
                }}
              >
                {t('Ticket.typeInfo')}
              </Typography>
            </Grid>
            {/* ISSUE PRODUCT HEADER */}
            <Grid item xs={12} sx={{ p: 0, pr: 1, mt: -3, mb: 1 }}>
              <FormBox
                Icon={DevicesOtherRoundedIcon}
                title={t('Ticket.issueProduct')}
              />
            </Grid>
            {/* ISSUE PRODUCT */}
            <Grid item xs={5} sx={{ m: 0, pr: 1, mb: -1 }}>
              {!isEmptyObject(state.ticket?.companyProductWithError) ? (
                <>
                  <SingleTicketContactProduct
                    product={state.ticket.companyProductWithError}
                  />
                  <Grid
                    item
                    sx={{
                      position: 'relative',
                      bottom: 78,
                      right: 8,
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    {state.employee.employee.id !== 'new' &&
                      state.company.id !== 'new' && (
                        <CompanyProductDrawer
                          buttonIcon={
                            <ChangeCircleIcon sx={{ fontSize: 26 }} />
                          }
                          buttonContext={t('Ticket.selectIssueProduct')}
                          companyId={state.company?.id ?? 'new'}
                          employeeId={state.employee.employee.id ?? 'new'}
                          handleChange={handleChangeCompanyProductWidthError}
                        />
                      )}
                  </Grid>
                </>
              ) : (
                <Grid
                  item
                  sx={{
                    width: '100%',
                    height: '100%',
                  }}
                >
                  <CompanyProductDrawer
                    buttonIcon={null}
                    buttonContext={t('Ticket.selectIssueProduct')}
                    companyId={state.company?.id ?? 'new'}
                    employeeId={state.employee.employee.id ?? 'new'}
                    handleChange={handleChangeCompanyProductWidthError}
                  />
                </Grid>
              )}
            </Grid>
            <Grid item xs={7} sx={{ m: 0, pr: 1, mt: -1, mb: -1 }}>
              <Typography
                sx={{
                  m: 0,
                  pl: 1,
                  flexGrow: 1,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  fontWeight: 'normal',
                  fontSize: 12,
                  letterSpacing: 2,
                  width: '100%',
                }}
              >
                {t('Ticket.tickerProduct')}
              </Typography>
            </Grid>

            {/* JOBTYPE HEADER */}
            <Grid item xs={12} sx={{ p: 0, pr: 1, mt: 2, mb: 1 }}>
              <FormBox
                Icon={DevicesOtherRoundedIcon}
                title={t('Ticket.jobType')}
              />
            </Grid>
            {/* JOB TYPE */}
            <Grid item xs={3} sx={{ pr: 2 }}>
              <Select
                sx={{ width: '100%', p: 0, mt: -0.5 }}
                labelId='JobType'
                id='JobType'
                variant='standard'
                value={state.ticket.jobType}
                label='Job Type'
                onChange={(e) => {
                  dispatch({ type: 'SET_JOB_TYPE', payload: e.target.value });
                }}
              >
                <MenuItem value={0}>None</MenuItem>
                <MenuItem value={1}>Support</MenuItem>
                <MenuItem value={2}>OnBoarding</MenuItem>
                <MenuItem value={3}>OffBoarding</MenuItem>
                <MenuItem value={4}>ReplaceProduct</MenuItem>
                <MenuItem value={5}>AssignProduct</MenuItem>
                <MenuItem value={6}>NewProduct</MenuItem>
                <MenuItem value={7}>Service</MenuItem>
              </Select>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      {/* RIGHT SIDE */}
      <Grid
        item
        xs={7}
        sx={{
          pl: 0.5,
          pr: 0.5,
        }}
      >
        <Grid
          container
          sx={{
            p: 2,
            borderRadius: 2,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            display: 'flex',
            flexDirection: 'row',
            backgroundColor: 'primary.main',
            height: Math.ceil(height - 102),
          }}
        >
          {/* TICKET TITLE */}
          <Grid item sx={{ flexGrow: 1, height: 20 }}>
            <Typography
              sx={{
                ...ProductFormStyle.SubHeader,
                ...{
                  pl: 2,
                  fontSize: '18px',
                  mb: 1,
                },
              }}
            >
              {state?.ticket?.title || ''}
            </Typography>
          </Grid>
          {/* TICKET NO */}
          <Grid item sx={{}}>
            <Typography
              sx={{
                ...ProductFormStyle.SubHeader,
                ...{
                  pl: 2,
                  fontSize: '18px',
                  mb: 1,
                  pr: 2,
                  letterSpacing: 2,
                  color: 'info.text',
                },
              }}
            >
              {state.ticketPost?.ticket?.ticketNo || ''}
            </Typography>
          </Grid>
          <List
            sx={{
              height: Math.ceil(height - 242),
              width: '100%',
              mb: 0,
              p: 2,
              backgroundColor: 'primary.main',
              overflow: 'auto',
            }}
          >
            <Grid container key={'container'} sx={{}}>
              <Stack direction={'column'} key='stack' flex={1} sx={{}}>
                <Grid
                  container
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    mb: 1,
                  }}
                >
                  {/* RESPONISBLE */}
                  <Grid item xs={7} sx={{ m: 0, p: 0, mb: 1 }}>
                    <Grid
                      container
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                      }}
                    >
                      <Grid item xs={7} sx={{ m: 0, p: 0, mb: 1 }}>
                        {state.ticket.responsible !== null ? (
                          <Grid
                            item
                            xs={12}
                            sx={{ p: 0, mb: 0.5, position: 'relative' }}
                          >
                            <SingleTicketEmployeeView
                              employee={state.ticket.responsible}
                              priority={0}
                            />
                            <Grid
                              item
                              sx={{
                                position: 'absolute',
                                top: 0,
                                right: 3,
                              }}
                            >
                              <ObjectDrawer
                                buttonContext={t(
                                  'Ticket.TicketDetails.selectEmployee'
                                )}
                                buttonIcon={
                                  <ChangeCircleIcon sx={{ fontSize: 26 }} />
                                }
                                objectList={
                                  !!objectDrawerList ? objectDrawerList : []
                                }
                                objectType={[EnumObjectType.AppOwnerEmployees]}
                                handleChange={handleChangeResponsable}
                                buttonHeight={30}
                                buttonWidth={30}
                              />
                            </Grid>
                          </Grid>
                        ) : (
                          <Box sx={[boxStyle.base, { height: 60 }]}>
                            <Button
                              sx={{
                                mx: 'auto',
                                width: '100%',
                                height: '100%',
                                borderRadius: 3,
                              }}
                              variant='contained'
                              onClick={(e) => {
                                handleAssigneMe();
                              }}
                            >
                              <Typography sx={[TextStyle.text, {}]}>
                                {t(
                                  'Ticket.TicketCommunications.assignCustomerEmployee'
                                )}
                              </Typography>
                            </Button>
                            <Grid
                              item
                              sx={{
                                position: 'relative',
                                top: 0,
                                right: 3,
                              }}
                            >
                              <ObjectDrawer
                                buttonContext={t(
                                  'Ticket.TicketDetails.selectEmployee'
                                )}
                                buttonIcon={
                                  <ChangeCircleIcon sx={{ fontSize: 26 }} />
                                }
                                objectList={
                                  !!objectDrawerList ? objectDrawerList : []
                                }
                                objectType={[EnumObjectType.AppOwnerEmployees]}
                                handleChange={handleChangeResponsable}
                                buttonHeight={30}
                                buttonWidth={30}
                              />
                            </Grid>
                          </Box>
                        )}
                      </Grid>
                      <Grid item xs={5} sx={{ m: 0, pl: 1, mb: 1 }}>
                        {state?.ticketPost?.ticket?.fixedHourlyRate > -1 ? (
                          <Grid sx={[gridStyle.base, { height: 60 }]}>
                            <Typography sx={[TextStyle.textCenter, {}]}>
                              {t('Ticket.TicketCommunications.fixedHourlyRate')}
                            </Typography>
                            <Typography
                              sx={[
                                TextStyle.textCenter,
                                {
                                  pt: 1,
                                  fontSize: 20,
                                  color: 'secondary.text',
                                },
                              ]}
                            >
                              {state.ticketPost.ticket.fixedHourlyRate.toFixed(
                                2
                              )}
                            </Typography>
                          </Grid>
                        ) : state.ticketPost.ticketPost?.workRole?.id ? (
                          <Grid sx={[gridStyle.base, { height: 60 }]}>
                            <Stack
                              direction='row'
                              spacing={0}
                              justifyContent={'space-between'}
                            >
                              {state.ticketPost.ticketPost?.workRole ? (
                                <Typography
                                  sx={[
                                    TextStyle.infoCenter,
                                    {
                                      pt: 0.5,
                                      fontSize: 12,
                                      letterSpacing: 2,
                                      color: 'primary.text',
                                    },
                                  ]}
                                >
                                  {t('Ticket.TicketCommunications.support')}
                                </Typography>
                              ) : (
                                <Typography
                                  sx={[
                                    TextStyle.infoCenter,
                                    {
                                      pt: 0.5,
                                      fontSize: 12,
                                      color: 'primary.text',
                                    },
                                  ]}
                                >
                                  {state.ticketPost.ticketPost?.workRole?.title}
                                </Typography>
                              )}

                              <ObjectDrawer
                                buttonContext={t(
                                  'Ticket.TicketCommunications.selectWorkRole'
                                )}
                                buttonIcon={<ChangeCircleIcon />}
                                objectList={
                                  !!objectDrawerList ? objectDrawerList : []
                                }
                                objectType={[EnumObjectType.WorkRole]}
                                handleChange={handleChangeWorkRole}
                                buttonHeight={30}
                                buttonWidth={30}
                              />
                            </Stack>

                            {state?.ticketPost?.ticketPost?.isInHouse ? (
                              <Typography
                                sx={[
                                  TextStyle.textCenter,
                                  {
                                    pt: 0,
                                    fontSize: 18,
                                    color: 'secondary.text',
                                  },
                                ]}
                              >
                                {state.ticketPost.ticketPost?.workRole?.inHouseHourlyRate.toFixed(
                                  2
                                )}
                              </Typography>
                            ) : (
                              <Typography
                                sx={[
                                  TextStyle.textCenter,
                                  {
                                    pt: 0,
                                    fontSize: 18,
                                    color: 'secondary.text',
                                  },
                                ]}
                              >
                                {state?.ticketPost?.ticketPost?.workRole?.onSiteHourlyRate.toFixed(
                                  2
                                ) || 0}
                              </Typography>
                            )}
                          </Grid>
                        ) : (
                          <ObjectDrawer
                            buttonContext={t(
                              'Ticket.TicketCommunications.selectWorkRole'
                            )}
                            buttonIcon={null}
                            objectList={
                              !!objectDrawerList ? objectDrawerList : []
                            }
                            objectType={[EnumObjectType.WorkRole]}
                            handleChange={handleChangeWorkRole}
                            buttonHeight={60}
                            buttonWidth={'100%'}
                          />
                        )}
                      </Grid>
                      <Grid item xs={4} sx={{ pr: 0.5 }}>
                        <SwitchType
                          isChecked={state?.ticketPost?.ticketPost?.isBillable}
                          dispatch={dispatch}
                          type={'SET_BILLABLE'}
                          header={t('Ticket.TicketCommunications.Billable')}
                          showNotification={false}
                          disabled={
                            state.ticketPost.ticketPost.internal ||
                            !state.ticketPost.isEditable
                          }
                        />
                      </Grid>
                      <Grid item xs={4} sx={{ pl: 0.5 }}>
                        <SwitchType
                          isChecked={state.ticketPost.ticketPost.isOvertime}
                          dispatch={dispatch}
                          type={'SET_OVERTIME'}
                          header={t('Ticket.TicketCommunications.overtime')}
                          showNotification={state.ticketPost.isShowOverTime}
                          disabled={false || !state.ticketPost.isEditable}
                        />
                      </Grid>
                      <Grid item xs={4} sx={{ m: 0, pl: 1 }}>
                        <SwitchType
                          isChecked={state.ticketPost.ticketPost.isInHouse}
                          dispatch={dispatch}
                          type={'SET_IS_IN_HOUSE'}
                          header={t('Ticket.TicketCommunications.inHouse')}
                          showNotification={false}
                          disabled={false || !state.ticketPost.isEditable}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* BILLABLE TIME BUTTONS */}
                  <Grid
                    item
                    xs={5}
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                    }}
                  >
                    <Grid container sx={{ m: 0, pl: 1 }}>
                      <Grid
                        item
                        xs={12}
                        sx={{
                          m: 0,
                          p: 0,
                          pl: 1,
                          pr: 1,
                          mt: 0,
                          backgroundColor: 'rgba(0, 0, 0, 0.1)',
                          borderRadius: 2,
                          height: 60,
                        }}
                      >
                        <Stack direction='row' spacing={0} flexGrow={1}>
                          <Typography sx={[TextStyle.label, { width: '60%' }]}>
                            {t('Ticket.TicketCommunications.dateTime')}
                          </Typography>
                          <Typography
                            sx={[TextStyle.value, { pr: 2, pt: 0.5 }]}
                          >
                            {state.ticketPost.totalTime}
                          </Typography>
                          {state.ticketPost.isTotalTimeOpen ? (
                            <IconButton
                              sx={{ m: 0, p: 0 }}
                              onClick={(e) => {
                                dispatch({
                                  type: 'SET_TOTAL_TIME_OPEN',
                                  payload: false,
                                });
                              }}
                            >
                              <KeyboardArrowUpIcon />
                            </IconButton>
                          ) : (
                            <IconButton
                              sx={{ m: 0, p: 0 }}
                              onClick={(e) => {
                                dispatch({
                                  type: 'SET_TOTAL_TIME_OPEN',
                                  payload: true,
                                });
                                dispatch({
                                  type: 'SET_TOTAL_VALUE_OPEN',
                                  payload: false,
                                });
                              }}
                            >
                              <KeyboardArrowDownIcon />
                            </IconButton>
                          )}
                        </Stack>
                        <Stack
                          sx={{}}
                          direction={'row'}
                          justifyContent='left'
                          alignItems='left'
                          width={280}
                          spacing={0.5}
                        >
                          {[15, 30, 45, 60].map((interval, index: number) => (
                            <Button
                              disabled={false || !state.ticketPost.isEditable}
                              sx={{ width: '20%', fontSize: 12, height: 26 }}
                              variant='contained'
                              key={index}
                              onClick={(e) => handleSetTime(e, interval)}
                            >
                              {interval === 60 ? '+1:00' : `+0:${interval}`}
                            </Button>
                          ))}

                          {/* Reset Button */}
                          {true && (
                            <Button
                              disabled={false || !state.ticketPost.isEditable}
                              sx={{ width: '20%', fontSize: 12, height: 26 }}
                              variant='contained'
                              color='secondary'
                              onClick={() => {
                                dispatch({
                                  type: 'SET_START_DATE',
                                  payload: dayjs(new Date()),
                                });
                                dispatch({
                                  type: 'SET_END_DATE',
                                  payload: dayjs(new Date()),
                                });
                              }}
                            >
                              {t('Ticket.TicketCommunications.reset')}
                            </Button>
                          )}
                        </Stack>

                        {state.ticketPost.isTotalTimeOpen && (
                          <Grid
                            container
                            spacing={2}
                            sx={{
                              width: '100%',
                              flexDirection: 'column',
                              backgroundColor: 'primary.main',
                              borderRadius: 2,
                              ml: 0,
                              mt: 0,
                              zIndex: 1000,
                              position: 'relative',
                            }}
                          >
                            <Grid
                              item
                              xs={12}
                              sx={{
                                m: 0,
                                p: 0,
                                pl: 1,
                                pr: 2,
                                mt: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                              }}
                            >
                              <Stack direction={'row'} sx={{}}>
                                <Typography
                                  sx={{
                                    pt: 0.7,
                                    width: 100,
                                    letterSpacing: 1,
                                    textAlign: 'center',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 'bold',
                                    textTransform: 'capitalize',
                                    fontSize: 14,
                                  }}
                                >
                                  Start:
                                </Typography>

                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <DesktopDateTimePicker
                                    disabled={
                                      false || !state.ticketPost.isEditable
                                    }
                                    format='DD/MM/YYYY HH:mm'
                                    value={
                                      dayjs(
                                        state.ticketPost.ticketPost.startTime
                                      )
                                        ? state.ticketPost.ticketPost.startTime
                                        : dayjs(new Date())
                                    }
                                    onChange={(e) => {
                                      /* dispatch({
                                             type: 'SET_START_DATE',
                                             payload: dayjs(e),
                                           }); */
                                    }}
                                    ampm={false}
                                    views={[
                                      'year',
                                      'month',
                                      'day',
                                      'hours',
                                      'minutes',
                                    ]}
                                    slotProps={{
                                      textField: {
                                        sx: {
                                          '& .MuiInputBase-input': {
                                            fontSize: 14,
                                          },
                                          '& .MuiInputLabel-root': {
                                            fontSize: 14,
                                          },
                                        },
                                      } as any,
                                      openPickerIcon: {
                                        sx: {
                                          fontSize: 26,
                                        },
                                      } as any,
                                    }}
                                  />
                                </LocalizationProvider>
                              </Stack>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sx={{
                                m: 0,
                                p: 0,
                                pl: 1,
                                pr: 2,
                                mt: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                              }}
                            >
                              <Stack direction={'row'} sx={{}}>
                                <Typography
                                  sx={{
                                    pt: 0.7,
                                    width: 100,
                                    letterSpacing: 1,
                                    textAlign: 'center',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 'bold',
                                    textTransform: 'capitalize',
                                    fontSize: 14,
                                  }}
                                >
                                  {t('Ticket.TicketCommunications.end')}:
                                </Typography>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <DesktopDateTimePicker
                                    disabled={
                                      false || !state.ticketPost.isEditable
                                    }
                                    format='DD/MM/YYYY HH:mm'
                                    value={
                                      dayjs(state.ticketPost.ticketPost.endTime)
                                        ? state.ticketPost.ticketPost.endTime
                                        : null
                                    }
                                    onChange={(e) => {
                                      /*  dispatch({
                                             type: 'SET_END_DATE',
                                             payload: dayjs(e),
                                           }); */
                                    }}
                                    ampm={false}
                                    views={[
                                      'year',
                                      'month',
                                      'day',
                                      'hours',
                                      'minutes',
                                    ]}
                                    slotProps={{
                                      textField: {
                                        sx: {
                                          '& .MuiInputBase-input': {
                                            fontSize: 14,
                                          },
                                          '& .MuiInputLabel-root': {
                                            fontSize: 14,
                                          },
                                        },
                                      } as any,
                                      openPickerIcon: {
                                        sx: {
                                          fontSize: 26,
                                        },
                                      } as any,
                                    }}
                                  />
                                </LocalizationProvider>
                              </Stack>
                            </Grid>
                          </Grid>
                        )}
                      </Grid>

                      {/* ECONOMY VIEW */}
                      <Grid
                        item
                        xs={12}
                        sx={{
                          m: 0,
                          p: 0,
                          pl: 1,
                          pr: 1,
                          mt: 0,
                          backgroundColor: 'rgba(0, 0, 0, 0.1)',
                          borderRadius: 2,
                          height: 60,
                        }}
                      >
                        <Stack direction='row' spacing={0} flexGrow={1}>
                          <Typography sx={[TextStyle.label, { width: '60%' }]}>
                            {t('Ticket.TicketCommunications.economy')}
                          </Typography>
                          <Typography
                            sx={[TextStyle.value, { pr: 2, pt: 0.5 }]}
                          >
                            {(state.ticketPost.totalValue || 0).toFixed(2)}
                          </Typography>
                          {state.ticketPost.isTotalValueOpen ? (
                            <IconButton
                              sx={{ m: 0, p: 0 }}
                              onClick={(e) => {
                                dispatch({
                                  type: 'SET_TOTAL_VALUE_OPEN',
                                  payload: false,
                                });
                              }}
                            >
                              <KeyboardArrowUpIcon />
                            </IconButton>
                          ) : (
                            <IconButton
                              sx={{ m: 0, p: 0 }}
                              onClick={(e) => {
                                dispatch({
                                  type: 'SET_TOTAL_VALUE_OPEN',
                                  payload: true,
                                });
                              }}
                            >
                              <KeyboardArrowDownIcon />
                            </IconButton>
                          )}
                        </Stack>

                        {state.ticketPost.isTotalValueOpen && (
                          <Grid item xs={12} sx={{ m: 0, p: 0 }}>
                            {
                              <EconomyView
                                ticketPostBilling={
                                  state.ticketPost.ticketPostBilling
                                }
                                state={state.ticketPost}
                              />
                            }
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                {/* MESSAGE */}
                <Grid
                  container
                  spacing={0}
                  flexDirection={'row'}
                  sx={{ m: 0, p: 0, mt: 1 }}
                >
                  {/* NEW COMMUNICATION*/}

                  <Grid
                    item
                    xs={12}
                    sx={{
                      pl: 0.5,
                      pr: 0.5,
                      pt: 2,
                      backgroundColor: 'primary.main',
                    }}
                  >
                    <SearchFilter
                      Icon={TextsmsRoundedIcon}
                      Header={
                        isGuidEmpty(state.ticketPost.ticketPost.id)
                          ? `${t(
                              'Ticket.TicketCommunications.newCommunication'
                            )}`
                          : `${t(
                              'Ticket.TicketCommunications.editCommunication'
                            )}`
                      }
                      gfx={
                        <>
                          {state.ticketPost.ticketPost
                            .isBilled /*  || state.ticketPost.ticketPost.isEmailSendt  */ ? (
                            <Typography
                              sx={{
                                zIndex: 11,
                                position: 'absolute',
                                left: 400,
                                color: 'error.main',
                              }}
                            >
                              {state.ticketPost.ticketPost.isBilled &&
                                t('Ticket.TicketCommunications.isBilled')}
                              {/*  {state.ticketPost.ticketPost.isEmailSendt &&
                           t('Ticket.TicketCommunications.isEmailSendt')} */}
                            </Typography>
                          ) : (
                            <></>
                          )}
                        </>
                      }
                      filterValue={state.ticketPost.ticketPost.status}
                      handleFilterChange={(e: any) => {
                        dispatch({
                          type: 'CHANGE_STATUS',
                          payload: e,
                        });
                      }}
                      handleSearch={null}
                      selectList={ticketCommunicationStatus}
                    />
                  </Grid>
                  {/* NEW SCHEDULE TIME*/}
                  {state.ticketPost.scheduleTime &&
                    (state.ticketPost.ticketPost.status === 1 ||
                      state.ticketPost.ticketPost.status === 3 ||
                      state.ticketPost.ticketPost.status === 4) && (
                      <Grid
                        item
                        xs={12}
                        sx={{
                          key: 'scheduleTime',
                          border: 1,
                          borderColor: 'primary.back',
                          backgroundColor: 'rgba(0, 0, 0, 0.1)',
                          p: 1,
                          mb: 2,
                        }}
                      >
                        <ScheduleView
                          scheduleTime={state.ticketPost.scheduleTime}
                          handleChange={handleChangeSchedule}
                        />
                      </Grid>
                    )}
                  <Grid item xs={12} sx={{ m: 0, pr: 0 }}>
                    <Grid
                      sx={{
                        flexGrow: 1,
                      }}
                    >
                      <Grid
                        sx={{
                          m: 0,
                          pb: 1,
                          flexGrow: 1,
                          backgroundColor: 'primary.back',
                          borderRadius: 2,
                        }}
                      >
                        <TextField
                          sx={{ m: 0, p: 0, backgroundColor: 'primary.main' }}
                          value={state.ticketPost.ticketPost.message}
                          defaultValue={state.ticketPost.ticketPost.message}
                          label={t(
                            'Ticket.TicketCommunications.internalTicket'
                          )}
                          variant='filled'
                          multiline={true}
                          disabled={false || !state.ticketPost.isEditable}
                          minRows={12}
                          maxRows={12}
                          onChange={(e) => {
                            dispatch({
                              type: 'EDIT_COMMENT',
                              payload: e.target.value,
                            });
                          }}
                        />
                        <Stack
                          direction='row'
                          spacing={0}
                          flexGrow={1}
                          sx={{ backgroundColor: 'rgb' }}
                        >
                          <Typography
                            sx={{
                              m: 0,
                              p: 0,
                              pl: 2,
                              letterSpacing: 1,
                              alignSelf: 'center',
                              alignContent: 'center',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              textTransform: 'capitalize',
                              fontSize: 14,
                              flexGrow: 1,
                            }}
                          >
                            {t(
                              'Ticket.TicketCommunications.internalTicketMessage'
                            )}
                          </Typography>

                          <SwitchType
                            isChecked={state.ticketPost.ticketPost.internal}
                            dispatch={dispatch}
                            type={'SET_INTERNAL'}
                            header={null}
                            showNotification={false}
                            disabled={false || !state.ticketPost.isEditable}
                          />
                        </Stack>
                        {/* EMAIL TO */}
                        <Stack
                          direction='row'
                          spacing={0}
                          flexGrow={1}
                          sx={{
                            backgroundColor:
                              state.ticketPost.ticketPost.status === 3 ||
                              state.ticketPost.ticketPost.status === 4 ||
                              state.ticketPost.ticketPost.status === 5 ||
                              state.ticketPost.ticketPost.status === 6
                                ? 'success.dark'
                                : 'transparent',
                            border: 2,
                            borderColor:
                              state.ticketPost.ticketPost.status === 3 ||
                              state.ticketPost.ticketPost.status === 4 ||
                              state.ticketPost.ticketPost.status === 5 ||
                              state.ticketPost.ticketPost.status === 6
                                ? 'success.light'
                                : 'transparent',
                            borderRadius: 2,
                          }}
                        >
                          <Typography
                            sx={{
                              m: 0,
                              p: 0,
                              pl: 2,
                              width: 140,
                              letterSpacing: 1,
                              alignSelf: 'center',
                              alignContent: 'center',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              textTransform: 'capitalize',
                              fontSize: 14,
                            }}
                          >
                            {t('Ticket.TicketCommunications.sendEmailTo')}:
                          </Typography>

                          <Typography
                            sx={{
                              m: 0,
                              p: 0,
                              pl: 2,
                              letterSpacing: 1,
                              alignSelf: 'center',
                              alignContent: 'left',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              color: 'secondary.text',
                              flexGrow: 1,
                            }}
                          >
                            {state?.ticketPost?.ticketPost?.receiver?.email ||
                              ''}
                          </Typography>
                          <SwitchType
                            isChecked={state.ticketPost.ticketPost.isEmailSent}
                            dispatch={dispatch}
                            type={'IS_SEND_EMAIL'}
                            header={null}
                            showNotification={false}
                            disabled={
                              state.ticketPost.ticketPost.internal ||
                              !state.ticketPost.isEditable ||
                              !state.ticketPost.isEmailAllowed
                            }
                          />
                        </Stack>
                        {/* EMAIL TO */}
                        <Stack
                          direction='row'
                          spacing={0}
                          flexGrow={1}
                          sx={{
                            backgroundColor:
                              state.ticketPost.ticketPost.status === 3 ||
                              state.ticketPost.ticketPost.status === 4 ||
                              state.ticketPost.ticketPost.status === 5 ||
                              state.ticketPost.ticketPost.status === 6
                                ? 'success.dark'
                                : 'transparent',
                            border: 2,
                            borderColor:
                              state.ticketPost.ticketPost.status === 3 ||
                              state.ticketPost.ticketPost.status === 4 ||
                              state.ticketPost.ticketPost.status === 5 ||
                              state.ticketPost.ticketPost.status === 6
                                ? 'success.light'
                                : 'transparent',
                            borderRadius: 2,
                          }}
                        >
                          <Typography
                            sx={{
                              m: 0,
                              p: 0,
                              pl: 2,
                              width: 180,
                              letterSpacing: 1,
                              alignSelf: 'center',
                              alignContent: 'center',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              textTransform: 'capitalize',
                              fontSize: 14,
                            }}
                          >
                            {t('Ticket.TicketCommunications.ccEmailTo')}:
                          </Typography>

                          <TextField
                            name='name'
                            onFocus={handleFocus}
                            sx={{
                              fontSize: 10,
                              color: 'info.text',
                              '& .Mui-focused': {
                                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                              },
                              backgroundColor: 'rgba(0, 0, 0, 0.05)',
                            }}
                            disabled={true}
                            value={state.ticket.ccEmailList}
                            onChange={(e) => handleChangeCC(e)}
                          />
                          <SwitchType
                            isChecked={state.ticketPost.ticketPost.isCCSent}
                            dispatch={dispatch}
                            type={'IS_SEND_EMAIL_CC'}
                            header={null}
                            showNotification={false}
                            disabled={
                              state.ticketPost.ticketPost.internal ||
                              !state.ticketPost.isEditable ||
                              !state.ticketPost.isEmailAllowed
                            }
                          />
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Stack>
            </Grid>
            {/* ATTATCHMENTS */}
            <Grid item xs={12} sx={{ pr: 0.5, pl: 0.5, direction: 'row' }}>
              <Accordion
                disableGutters
                sx={{
                  backgroundColor: 'transparent',
                  border: 0,
                  m: 1,
                }}
              >
                <FormAccordionSummary
                  Icon={AttachFileIcon}
                  title={t('Ticket.TicketCommunications.attachments')}
                />
                <AccordionDetails>
                  <DocumentUploader
                    setDocuments={(files: any) =>
                      setSelectedDocuments((prevDocs: any) => [
                        ...prevDocs,
                        ...files,
                      ])
                    }
                  />
                  <List>
                    {state.ticketPost.ticketPost.attachments?.map(
                      (document: any, index: number) => {
                        //console.log('document:', document);
                        return (
                          <ListItem key={index}>
                            {document.url ? (
                              <a
                                rel='noopener noreferrer'
                                target='_blank'
                                href={document.url}
                                style={{ color: 'white' }}
                              >
                                {document.fileName}
                              </a>
                            ) : (
                              document.file.name
                            )}
                          </ListItem>
                        );
                      }
                    )}
                  </List>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </List>
          {/* FOTTER */}
          {/* SUBMIT*/}
          <Grid item xs={12} sx={{ pr: 0.5, pl: 0.5, direction: 'row' }}>
            <Stack direction={'column'}>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'right',
                }}
              >
                {isValidGuid(state.ticketPost.ticketPost.id) && (
                  <Button
                    sx={{
                      width: '25%',
                      backgroundColor: 'primary.back',
                    }}
                    onClick={(e: any) => {
                      e.preventDefault();
                      /* dispatch({
                             type: 'REMOVE_TICKET_POST',
                             payload: state.ticketPost.ticketPost.id,
                           });
                           dispatch({
                             type: 'SET_IS_EDITABLE',
                             payload: true,
                           }); */
                    }}
                    variant='contained'
                  >
                    {t('Ticket.TicketCommunications.Cancel')}
                  </Button>
                )}
                <Button
                  disabled={isEditDisabled()}
                  sx={{
                    width: '50%',
                    // backgroundColor: 'secondary.main',
                  }}
                  type='submit'
                  onClick={(e: any) => {
                    e.preventDefault();
                    onSubmit();
                    /*  dispatch({
                           type: 'SET_IS_EDITABLE',
                           payload: false,
                         }); */
                  }}
                  id={
                    isGuidEmpty(state.ticketPost.ticketPost.id)
                      ? `${t('Ticket.TicketCommunications.submit')}`
                      : `${t('Ticket.TicketCommunications.confirmEdit')}`
                  }
                  variant='contained'
                >
                  {isGuidEmpty(state.ticketPost.ticketPost.id)
                    ? `${t('Ticket.TicketCommunications.submit')}`
                    : `${t('Ticket.TicketCommunications.confirmEdit')}`}
                </Button>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
